import { writable } from 'svelte/store'

export const navbarMenu = writable(false);

export const navbarTitle = writable('App');

export const showNavbarImage = writable(false);

export const drawerOpen = writable(false);

export const showBack = writable(false);

export const back = writable(false);

export const currentView = writable(0);

export const prevView = writable(-1);

export const currentViewObject = writable({});

export const notInPreview = writable(false);

export const iframeConfig = writable(null);

export const updateApp = writable(false);

